import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/offer';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-carbon-900 py-16 sm:py-20 lg:py-28" aria-labelledby="faq-heading" data-id="element-67" data-mp="1gkn1vhlldcqo">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-68" data-mp="249pu1jduqnzf">
        <SectionHeading id="faq-heading" eyebrow="FAQ" title="Before you decide" data-id="element-69" data-mp="28bb2msjcsg3t" />

        <dl className="mx-auto mt-12 max-w-2xl space-y-4 sm:mt-14" data-id="element-70" data-mp="1ujms2tor5zoy">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-carbon-line bg-carbon-800" data-id="element-71" data-mp="1zg4u3lsp7jxl" data-mpi={index}>
                <dt data-id="element-72" data-mp="2rzk3rs2vjwfg">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-carbon-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mint sm:gap-6 sm:px-6 sm:py-5" data-id="element-73" data-mp="2s0v9vyjslg9q">
                    <span className="text-sm font-semibold leading-snug text-paper sm:text-base" data-id="element-74" data-mp="1oihzkm7ofet4">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-mint" aria-hidden="true" data-id="element-75" data-mp="1xk7s5vdaojsh" /> : <PlusIcon className="h-5 w-5 shrink-0 text-mint" aria-hidden="true" data-id="element-76" data-mp="1sm693afvckh0" />}
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-77" data-mp="3ucho4ow5w1ba">
                  {isOpen && <motion.dd initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-78" data-mp="3uem3c2zigmqv">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-paper-dim sm:px-6 sm:text-base" data-id="element-79" data-mp="2c9npwixu3bpl">
                        {faq.answer}
                      </p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}